import { apiURL, olderToken, oldToken, token } from "./constant";

import React, { useEffect, useState } from "react";
import { createContext } from "react";

export const DataContext = createContext({});

export default function DataContainer({ children }) {
  const [data, setData] = useState({
    agenda: [],
    speakers: [],
    sponsors: [],
  });
  const [pastData, setPastData] = useState({
    pastSpeakers: [],
    pastSponsors: [],
  });
  const [pastData2, setPastData2] = useState({
    past2Speakers: [],
    past2Sponsors: [],
  });
  async function fetchData() {
    await fetch(`${apiURL}/getEventData`, {
      method: "get",
      headers: new Headers({
        Authorization: oldToken,
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setPastData({
          pastSpeakers: data.speakers.filter((s) => !s.hideSpeaker),
          pastSponsors: data.sponsors.filter((s) => s.isActive),
        });
      })
      .catch((err) => console.log(err));

    await fetch(`${apiURL}/getEventData`, {
      method: "get",
      headers: new Headers({
        Authorization: olderToken,
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setPastData2({
          past2Speakers: data.speakers.filter((s) => !s.hideSpeaker),
          past2Sponsors: data.sponsors.filter((s) => s.isActive),
        });
      })
      .catch((err) => console.log(err));

    await fetch(`${apiURL}/getEventData`, {
      method: "get",
      headers: new Headers({
        Authorization: token,
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setData({
          speakers: data.speakers.filter((s) => !s.hideSpeaker),
          sponsors: data.sponsors.filter((s) => s.isActive),
        });
      })
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <DataContext.Provider value={{ ...data, ...pastData, ...pastData2 }}>
      {children}
    </DataContext.Provider>
  );
}
